import { render, staticRenderFns } from "./CurrentVehicle.vue?vue&type=template&id=07489942&"
import script from "./CurrentVehicle.vue?vue&type=script&lang=js&"
export * from "./CurrentVehicle.vue?vue&type=script&lang=js&"
import style0 from "./CurrentVehicle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports